/* tslint:disable */
/* eslint-disable */
/**
 * The Selling Partner API for FBA inbound operations.
 * The Selling Partner API for Fulfillment By Amazon (FBA) Inbound. The FBA Inbound API enables building inbound workflows to create, manage, and send shipments into Amazon\'s fulfillment network. The API has interoperability with the Send-to-Amazon user interface.
 *
 * The version of the OpenAPI document: 2024-03-20
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The page type to use to print the labels. Possible values: \'A4_21\', \'A4_24\', \'A4_24_64x33\', \'A4_24_66x35\', \'A4_24_70x36\', \'A4_24_70x37\', \'A4_24i\', \'A4_27\', \'A4_40_52x29\', \'A4_44_48x25\', \'Letter_30\'.
 */

export const ItemLabelPageType = {
    A421: 'A4_21',
    A424: 'A4_24',
    A42464x33: 'A4_24_64x33',
    A42466x35: 'A4_24_66x35',
    A42470x36: 'A4_24_70x36',
    A42470x37: 'A4_24_70x37',
    A424i: 'A4_24i',
    A427: 'A4_27',
    A44052x29: 'A4_40_52x29',
    A44448x25: 'A4_44_48x25',
    Letter30: 'Letter_30',
} as const;

export type ItemLabelPageType = typeof ItemLabelPageType[keyof typeof ItemLabelPageType];



